<template>
  <div
    v-if="isLoading"
    class="custom-global-skeleton tw-w-full tw-h-full"
  ></div>
  <div v-else class="tw-p-[20px] tw-min-h-[73px] tw-bg-[#FFF]">
    <div class="tw-flex tw-items-center tw-justify-between tw-mb-[14px]">
      <span
        class="tw-text-[15px] tw-font-[600] tw-leading-[130%] tw-text-[#211F58]"
        >{{
          getComponentUiText("app-scan-scanning-web-services-next-scan-title-1")
        }}
      </span>
      <a
        class="tw-text-[13px] tw-font-[500] tw-text-[#387DFF] tw-leading-[130%] tw-cursor-pointer"
        @click="editSchedule"
        >{{
          Boolean(scheduleData)
            ? getComponentUiText(
                "app-scan-scanning-web-services-next-scan-edit-title-1",
              )
            : getComponentUiText(
                "app-scan-scanning-web-services-next-scan-create-title-1",
              )
        }}</a
      >
    </div>

    <div>
      <div class="tw-flex tw-items-center tw-justify-between tw-mb-[6px]">
        <span
          class="tw-text-[13px] tw-font-[500] tw-leading-[130%] tw-text-[#211F58]"
          >{{
            getComponentUiText(
              "app-scan-scanning-web-services-next-scan-edit-content-1",
            )
          }}</span
        >
        <span
          class="tw-text-[13px] tw-font-[400] tw-text-[#878787] tw-leading-[130%] tw-max-w-[300px] tw-truncate"
          >{{
            Boolean(scheduleData)
              ? dateFrequency
              : getComponentUiText(
                  "app-scan-scanning-web-services-next-scan-default-frequency-title-1",
                )
          }}</span
        >
      </div>
      <div class="tw-flex tw-items-center tw-justify-between">
        <span
          class="tw-text-[13px] tw-font-[500] tw-leading-[130%] tw-text-[#211F58]"
          >{{
            getComponentUiText(
              "app-scan-scanning-web-services-next-scan-title-1",
            )
          }}
        </span>
        <span
          class="tw-text-[13px] tw-font-[400] tw-text-[#878787] tw-leading-[130%]"
          >{{
            Boolean(scheduleData)
              ? dateAgo
              : getComponentUiText(
                  "app-scan-scanning-web-services-next-scan-default-next-scan-time-title-1",
                )
          }}
        </span>
      </div>
    </div>
  </div>

  <ScheduleModal
    :show="show"
    :title="getComponentUiText('app-scanning-schedule-modal-title-content-1')"
    :description="
      getComponentUiText('app-scanning-schedule-modal-description-1')
    "
    :button-text="getComponentUiText('app-scanning-schedule-modal-button-1')"
    :is-edit="true"
    :scan-target-type="`${
      props.data.webserviceId
        ? TYPE_SCHEDULE.webservices
        : TYPE_SCHEDULE.domains
    }`"
    :target-id="props.data.id"
    @update:show="show = $event"
  />
</template>

<script setup>
import store from "@/store";
import { TYPE_SCHEDULE } from "@/utils/constants";
import { getNextScanFromRRule, getTextFromRRule } from "@/utils/rruleUtils";
import { getComponentUiText } from "@/utils/utilities";
import { computed, onMounted, ref, watch } from "vue";
import ScheduleModal from "./scheduleModal.vue";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const show = ref(false);

const scheduleData = computed(() =>
  store.getters["Scanning/GET_SCHEDULED_ITEM"]({
    type: props.data.webserviceId
      ? TYPE_SCHEDULE.webservices
      : TYPE_SCHEDULE.domains,
    id: props.data.id,
  }),
);

const isLoading = computed(() => store.state.Scanning.isLoadingSchedule);

const dateAgo = ref("");
const dateFrequency = ref("");

const changeTextToUIText = (text) => {
  return text
    .replace(
      "every weekday",
      getComponentUiText("app-scanning-schedule-modal-filed-every-weekday-1"),
    )
    .replace(
      "every",
      getComponentUiText("app-scanning-schedule-modal-filed-every-1"),
    )
    .replace(
      "Weekend day",
      getComponentUiText("app-scanning-schedule-modal-option-weekend-day-1"),
    )
    .replace(
      "last",
      getComponentUiText("app-scanning-schedule-modal-option-last-1"),
    )
    .replace(
      "Monday",
      getComponentUiText("app-scanning-schedule-modal-option-monday-1"),
    )
    .replace(
      "Tuesday",
      getComponentUiText("app-scanning-schedule-modal-option-tuesday-1"),
    )
    .replace(
      "Wednesday",
      getComponentUiText("app-scanning-schedule-modal-option-wednesday-1"),
    )
    .replace(
      "Thursday",
      getComponentUiText("app-scanning-schedule-modal-option-thursday-1"),
    )
    .replace(
      "Friday",
      getComponentUiText("app-scanning-schedule-modal-option-friday-1"),
    )
    .replace(
      "Saturday",
      getComponentUiText("app-scanning-schedule-modal-option-saturday-1"),
    )
    .replace(
      "Sunday",
      getComponentUiText("app-scanning-schedule-modal-option-sunday-1"),
    )
    .replace("days", getComponentUiText("app-notification-days-1"))
    .replace("day", getComponentUiText("app-scanning-day-1"))
    .replace("weeks", getComponentUiText("app-notification-weeks-ago-1"))
    .replace("week", getComponentUiText("app-notification-week-1"))
    .replace("months", getComponentUiText("app-notification-months-1"))
    .replace("month", getComponentUiText("app-notification-month-1"))
    .replace("years", getComponentUiText("app-notification-years-1"))
    .replace("year", getComponentUiText("app-notification-year-1"))
    .replace(
      "on the",
      getComponentUiText(
        "app-scanning-schedule-modal-filed-ends-on-the-1",
      ).toLowerCase(),
    )
    .replace(
      "on",
      getComponentUiText(
        "app-scanning-schedule-modal-filed-ends-on-1",
      ).toLowerCase(),
    )
    .replace("of", getComponentUiText("app-prospect-questions-progress-of-1"));
};

const changeNextScanToUIText = (text) => {
  return text
    .replace("in", getComponentUiText("app-scanning-schedule-next-scan-in-1"))
    .replace("minutes", getComponentUiText("app-notification-minutes-1"))
    .replace("minute", getComponentUiText("app-notification-minute-1"))
    .replace("hours", getComponentUiText("app-notification-hours-1"))
    .replace("hour", getComponentUiText("app-scanning-hour-1"))
    .replace("days", getComponentUiText("app-notification-days-1"))
    .replace("day", getComponentUiText("app-scaning-day-1"));
};

onMounted(() => {
  try {
    const rrule = scheduleData.value?.rrule;
    if (rrule) {
      dateFrequency.value = changeTextToUIText(getTextFromRRule(rrule));
      dateAgo.value = changeNextScanToUIText(getNextScanFromRRule(rrule));
    }
  } catch (error) {
    dateFrequency.value = "";
    dateAgo.value = "";
  }
});

watch(
  () => scheduleData.value,
  () => {
    try {
      const rrule = scheduleData.value?.rrule;
      if (rrule) {
        dateFrequency.value = changeTextToUIText(getTextFromRRule(rrule));
        dateAgo.value = changeNextScanToUIText(getNextScanFromRRule(rrule));
      }
    } catch (error) {
      dateFrequency.value = "";
      dateAgo.value = "";
    }
  },
);

const editSchedule = () => {
  show.value = true;
};
</script>
